import React, { useState, useEffect } from 'react';
import { List, Tooltip, Icon } from 'antd';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import { questionsConstants } from '../../../../../../constants/questions.constants';
import { selectedQuestionSelector } from '../../../../store/selectors';
import { setSelectedQuestion } from '../../../../store/actions';
import QuestionMeta from '../../../QuestionMeta/QuestionMeta';
import QuestionDescription from '../../../QuestionDescription/QuestionDescription';
import { needAnswer } from '../../../../utils/needAnswer';
import { isCloseQuestionRejected } from '../../../../utils/isCloseQuestionRejected';
import QuestionReactionIcon from '../../../QuestionReactionIcon/QuestionReactionIcon';
import { questionsRequestToCloseStateId } from '../../../../constants/common';
import styles from './ListItem.module.scss';

const QuestionId = ({ questionId }) => (
  <span className={styles.questionId}>{questionId}</span>
);

const CreateTime = ({ createTime }) =>
  createTime ? (
    <span>
      <Icon type="calendar-o" style={{ marginRight: '8px' }} />
      {moment(createTime).format('DD.MM.YY HH:mm')}
    </span>
  ) : null;

const NotAnswered = () => (
  <Tooltip title="Требуется ответ">
    <Icon type="message" theme="filled" className={styles.notNasweredIcon} />
  </Tooltip>
);

const CloseQuestionRejected = () => (
  <Tooltip title="Запрос на закрытие отклонен">
    <Icon type="minus-circle" className={styles.closeQuestionRejected} />
  </Tooltip>
);

const QuestionState = ({ stateName, stateId, closeRequestDateTime }) => (
  <Tooltip
    title={
      stateId === questionsRequestToCloseStateId && closeRequestDateTime
        ? `Отправлен ${moment(closeRequestDateTime).format('DD.MM.YYYY')}`
        : ''
    }
  >
    <span>
      {questionsConstants.questionStateIcon(stateId, 14, {
        verticalAlign: '-0.125em',
        marginRight: '8px',
      })}
      {stateName || ''}
    </span>
  </Tooltip>
);

const ListItem = ({ item }) => {
  const [actions, setActions] = useState([]);
  const dispatch = useDispatch();

  const selectedQuestion = useSelector(selectedQuestionSelector);

  const handleQuestionClick = () => {
    dispatch(setSelectedQuestion(item));
  };

  useEffect(() => {
    const {
      id: itemId,
      createTime,
      stateName,
      stateId,
      reactionName,
      closeRequestDateTime,
    } = item;

    let newActions = [
      <QuestionId questionId={itemId} key="1" />,
      <CreateTime createTime={createTime} key="2" />,
      <QuestionState
        stateName={stateName}
        stateId={stateId}
        closeRequestDateTime={closeRequestDateTime}
        key="4"
      />,
    ];

    if (needAnswer(item)) {
      newActions.splice(2, 0, <NotAnswered key="3" />);
    }

    if (isCloseQuestionRejected(item)) {
      newActions.push(<CloseQuestionRejected key="5" />);
    }

    if (reactionName) {
      newActions.push(
        <QuestionReactionIcon key="6" reactionName={reactionName} />
      );
    }

    setActions(newActions);
  }, [item]);

  return (
    <List.Item
      key={item.id}
      className={cn(styles.root, {
        [styles.selected]: selectedQuestion?.id === item.id,
      })}
      onClick={handleQuestionClick}
      actions={actions}
    >
      <QuestionMeta question={item} className={styles.questionMeta} />
      {item.description && (
        <QuestionDescription description={item.description} />
      )}
    </List.Item>
  );
};

export default ListItem;
